import { useState } from "react";

export const ProductGallery = ({ product }) => {
  const [active, setActive] = useState(0);
  const imgs = product.gallery.length ? product.gallery : [product.coverImage];

  return (
    <div data-testid="product-gallery" className="flex flex-col gap-4">
      <div className="overflow-hidden bg-[#EFECE6]">
        <img key={active} data-testid="gallery-main-image" src={imgs[active]} alt={`${product.name} — image ${active + 1}`} className="fade-in aspect-[3/2] w-full object-contain" />
      </div>
      {imgs.length > 1 && (
        <div className="grid grid-cols-4 gap-3 sm:grid-cols-5">
          {imgs.map((src, i) => (
            <button
              key={src + i}
              type="button"
              data-testid={`gallery-thumb-${i}`}
              aria-label={`Show image ${i + 1}`}
              onClick={() => setActive(i)}
              className={`overflow-hidden border transition-opacity duration-300 ${i === active ? "border-black opacity-100" : "border-transparent opacity-60 hover:opacity-100"}`}
            >
              <img src={src} alt="" loading="lazy" className="aspect-square w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
